"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateInfoNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'DATE-INFO';
class DateInfoNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            let { date } = params;
            if (!date) {
                return undefined;
            }
            if (this.config.timezone) {
                date = new Date(date.toLocaleString("en-US", { timeZone: this.config.timezone }));
            }
            return {
                monthNumber: (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1).toString(),
                monthAbbreviation: date.toLocaleString('default', { month: 'short' }),
                monthName: date.toLocaleString('default', { month: 'long' }),
                day: (date.getDate() < 10 ? '0' : '') + date.getDate().toString(),
                dayOfWeek: date.toLocaleString('default', { weekday: 'long' }),
                dayOfWeekAbbreviation: date.toLocaleString('default', { weekday: 'short' }),
                year: date.getFullYear().toString(),
                hour: (date.getHours() < 10 ? '0' : '') + date.getHours().toString(),
                minute: (date.getMinutes() < 10 ? '0' : '') + date.getMinutes().toString(),
            };
        };
        //TODO: Build the interface definition from the given schema....but what is our schema
        this._interfaceDefinition = Schema;
    }
}
exports.DateInfoNode = DateInfoNode;
DateInfoNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Date Info',
    isIdempotent: true,
    primaryCategory: 'Date/Time',
};
//# sourceMappingURL=DateInfo.js.map